import { render } from "./ThanksScene.vue?vue&type=template&id=728b038a"
import script from "./ThanksScene.vue?vue&type=script&lang=js"
export * from "./ThanksScene.vue?vue&type=script&lang=js"

import "./ThanksScene.vue?vue&type=style&index=0&id=728b038a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__